module.exports = __webpack_public_path__ + "static/media/mixed-use.5d5de258.svg";